import React, { FC, useEffect, useState } from 'react';
import { getAdminToken } from '../shared/storageService/cookieService';
import { useStoreContext } from '../state';
import { getAdminTokenFromApi } from './getAuthFromApi';
import { ProgressSpinner } from '../components/ProgressSpinner';
import { useAppSelector } from '../redux/hooks';

interface AdminAuthWrapperProps {
    children: React.ReactElement;
}
// this wrapper should wrap component that requires okta authorization
const AdminAuthWrapper: FC<AdminAuthWrapperProps> = ({ children }) => {
    const [hasToken, setHasToken] = useState<boolean>(false);
    const {
        state: { userId, role, UserRights },
    } = useStoreContext();

    const reduxUserId = useAppSelector((state) => state.store.userId);
    const reduxRole = useAppSelector((state) => state.store.role);
    const reduxUserRights = useAppSelector((state) => state.store.userRights);

    useEffect(() => {
        (async () => {
            await getAdminTokenFromApi({
                name: reduxUserRights?.allowedPlatforms?.[0],
                userId: reduxUserId,
                role: reduxRole,
                formUserRights: 2,
            });
            if (getAdminToken()) setHasToken(true);
        })();
    }, [
        userId,
        role,
        reduxUserRights?.allowedPlatforms,
        reduxUserId,
        reduxRole,
    ]);
    if (!hasToken)
        return (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <ProgressSpinner />
            </div>
        );
    return children;
};

export default AdminAuthWrapper;
